import { cymbioColors } from '../../../utils/colors';
import { graphCurrencyFormatter, graphNumberFormatter } from '../utils';
import { getSalesByChannelsPieGraphDescription } from './legends.utils';

export function PieCenteredMetric({ isGmvMetric, currency, currentOrderType }) {
  return (canvasContext) => {
    const total = canvasContext.dataWithArc.reduce((sum, data) => {
      return sum + Number(data.data.total);
    }, 0);

    const totalDisplay = isGmvMetric ? graphCurrencyFormatter(total, currency) : graphNumberFormatter(total);
    const description = getSalesByChannelsPieGraphDescription(currentOrderType);

    return (
      <svg>
        <text
          textAnchor="middle"
          dominantBaseline="central"
          x={canvasContext.centerX}
          y={canvasContext.centerY - 12}
          style={{
            font: '"Nunito", sans-serif',
            fontSize: 24,
            fontWeight: 700,
            fill: cymbioColors.analytics.textPrimary,
            outlineWidth: 0,
            outlineColor: 'transparent',
          }}
        >
          {totalDisplay}
        </text>
        <text
          textAnchor="middle"
          dominantBaseline="central"
          x={canvasContext.centerX}
          y={canvasContext.centerY + 12}
          style={{
            font: '"Rubik", sans-serif',
            fontSize: 12,
            fill: cymbioColors.analytics.textSecondary,
            fontWeight: 300,
            outlineWidth: 0,
            outlineColor: 'transparent',
          }}
        >
          {description}
        </text>
      </svg>
    );
  };
}
